<template>
  <div class="rd-screen">
    <report-tools :copy="rows.length > 0" @copy="copyTable"></report-tools>

    <report-state
      v-if="!selectedCompanies.length"
      icon="mdi-domain"
      :title="$t('no_companies_selected')"
    ></report-state>
    <report-state v-else-if="loading" kind="loading"></report-state>
    <report-state
      v-else-if="!rows.length"
      icon="mdi-pot-steam-outline"
      :title="emptyTitle"
      :text="emptyText"
    ></report-state>

    <div v-else class="ui-card rd-card">
      <table class="ui-table rd-tbl mr-grouped">
        <thead>
          <tr>
            <th scope="col" class="rd-col-num">#</th>
            <th scope="col">{{ $t("meals_main") }}</th>
            <th v-for="shift in activeShifts" :key="shift.id" scope="col" class="is-right">
              <report-shift-tag :shift="shift.id"></report-shift-tag>
            </th>
            <th scope="col" class="is-right">{{ $t("total") }}</th>
          </tr>
        </thead>
        <tbody v-for="section in sections" :key="section.key">
          <tr class="mr-group">
            <th :colspan="activeShifts.length + 3" scope="colgroup">
              <button
                type="button"
                class="mr-group__btn"
                :aria-expanded="String(!collapsed[section.key])"
                @click="toggle(section.key)"
              >
                <v-icon size="18">{{ collapsed[section.key] ? "mdi-chevron-right" : "mdi-chevron-down" }}</v-icon>
                <b>{{ section.name }}</b>
                <span class="rd-muted rd-num">{{ section.rows.length }}</span>
                <span class="mr-group__sum rd-num">{{ section.total }}</span>
              </button>
            </th>
          </tr>
          <template v-if="!collapsed[section.key]">
            <tr v-for="row in section.rows" :key="row.num">
              <td class="rd-num rd-muted">{{ row.num }}</td>
              <td class="is-name" :title="row.title">{{ row.label }}</td>
              <td
                v-for="shift in activeShifts"
                :key="shift.id"
                class="is-right rd-num"
                :class="{ 'is-zero': !row[shift.key] }"
              >
                {{ row[shift.key] }}
              </td>
              <td class="is-right rd-num"><b>{{ row.total }}</b></td>
            </tr>
          </template>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td>{{ $t("total") }}</td>
            <td v-for="shift in activeShifts" :key="shift.id" class="is-right rd-num">{{ totalFor(shift.key) }}</td>
            <td class="is-right rd-num">{{ totalFor("total") }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import ReportMealsTabDishes from "@/components/report/more-restaurants/tabs/ReportMealsTabDishes.vue";
import hasShiftBinding from "../../../shared/hasShiftBinding";
import hasMoreDishSections from "../../../shared/more/hasMoreDishSections";
import hasShiftSubtitle from "../../../shared/hasShiftSubtitle";
import ReportShiftTag from "../../../shared/ReportShiftTag.vue";
import { copyText, rowsToTsv } from "../../copyTable";
import ReportState from "../../ReportState.vue";
import ReportTools from "../../ReportTools.vue";

/**
 * Jela firmi "više restorana" na računaru: šta kuhinja sprema (paketi razloženi na jela), po grupi jela i smeni.
 * Grupe se mogu sklopiti. Firme, smene i pretragu čita iz zajedničke trake. Nasleđuje učitavanje, štampu i Excel
 * iz starog taba (redosled grupa je po `sort`).
 */
export default {
  name: "ReportDesktopMoreDishes",
  extends: ReportMealsTabDishes,
  mixins: [hasShiftBinding, hasShiftSubtitle, hasMoreDishSections],
  components: { ReportShiftTag, ReportState, ReportTools },
  computed: {
    emptyText() {
      return this.filters.search ? "" : this.$t("report_desktop.empty_hint");
    },
    kpis() {
      return [
        { key: "total", label: this.$t("report_desktop.total_meals"), value: this.totalFor("total"), tone: "inverse" },
        { key: "dishes", label: this.$t("meals_main"), value: this.rows.length },
      ];
    },
  },
  watch: {
    kpis: {
      handler(kpis) {
        this.$emit("kpis", this.rows.length ? kpis : []);
      },
      immediate: true,
    },
    loading: {
      handler(loading) {
        this.$emit("loading", loading);
      },
      immediate: true,
    },
  },
  methods: {
    async copyTable() {
      const headers = [this.$t("group"), this.$t("meals_main"), ...this.activeShifts.map((shift) => this.$t(shift.label)), this.$t("total")];
      const rows = this.sections.flatMap((section) =>
        section.rows.map((row) => [section.name, row.label, ...this.activeShifts.map((shift) => row[shift.key]), row.total])
      );
      const copied = await copyText(rowsToTsv(headers, rows));
      this.$emit("toast", this.$t(copied ? "report_desktop.copied" : "report_desktop.copy_failed"));
    },
  },
};
</script>
